import { render } from "./SwordModal.vue?vue&type=template&id=623d2124&scoped=true"
import script from "./SwordModal.vue?vue&type=script&lang=js"
export * from "./SwordModal.vue?vue&type=script&lang=js"

import "./SwordModal.vue?vue&type=style&index=0&id=623d2124&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623d2124"]])

export default __exports__